<template>
  <div class="main-page-wrapper">
    <Overview v-if="switch_tab == 'overview'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Overview>
    <Events v-if="switch_tab == 'events'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Events>
    <Projects v-if="switch_tab == 'projects'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Projects>
    <Contacts v-if="switch_tab == 'contacts'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Contacts>
    <Attachments v-if="switch_tab == 'attachments'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Attachments>
    <Notes v-if="switch_tab == 'notes'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Notes>
    <Activities v-if="switch_tab == 'activities'" @tab="(tab) => {
        switch_tab = tab;
      }
      "></Activities>
  </div>
</template>
<script>
import Overview from "@/views/Accounts/AccountsView/Overview.vue";
import Projects from "@/views/Accounts/AccountsView/Projects.vue";
import Contacts from "@/views/Accounts/AccountsView/Contacts.vue";
import Attachments from "@/views/Accounts/AccountsView/Attachments.vue";
import Notes from "@/views/Accounts/AccountsView/Notes.vue";
import Activities from "@/views/Accounts/AccountsView/Activities.vue";
export default {
  name: "account-view",
  components: {
    Overview,
    Projects,
    Contacts,
    Attachments,
    Notes,
    Activities,
  },
  data() {
    return {
      switch_tab: "overview",
      account: {},
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.switch_tab = val;
    },
  },
  mounted() {
    let vm = this;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.main-page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
}
</style>
